import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "flex items-center w-full",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "sr-only"
}
const _hoisted_3 = ["aria-current"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const NARROW_WIDTH_PX = 840
const DOT_RADIUS_PX = 8


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleStepper',
  props: {
    steps: {},
    current: {},
    hideLabels: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



// Abaixo desta largura os nomes descem para text-xs (Q12).
const rootEl = ref<HTMLElement | null>(null)
const insetLeft = ref(0)
const insetRight = ref(0)
const narrow = ref(false)

// Uma coluna por etapa, da largura do vão entre bolinhas e centrada em cada bolinha.
// As colunas das pontas avançam sobre o recuo do trilho, mas o texto não passa dele.
const labelGridStyle = computed(() => {
  const count = props.steps.length
  const gap = count > 1 ? `((100% - ${2 * DOT_RADIUS_PX}px) / ${count - 1})` : '100%'
  return {
    width: `calc(${count} * ${gap})`,
    marginLeft: `calc(${DOT_RADIUS_PX}px - ${gap} / 2)`,
    gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`
  }
})

function labelColorClass(index: number) {
  if (index === props.current) return 'font-bold text-primary30'
  return index < props.current ? 'text-primary30' : 'text-gray-400'
}

// Ref em v-for não garante a ordem do array no Vue 3: as pontas vêm do DOM.
function edgeLabels(): HTMLElement[] {
  const labels = rootEl.value?.querySelectorAll<HTMLElement>(
    '[data-testid="create-schedule-step-label"]'
  )
  return labels?.length ? [labels[0], labels[labels.length - 1]] : []
}

// O trilho recua só meia largura do nome de cada ponta: as bolinhas ficam
// equidistantes e nenhum nome centralizado passa da borda.
function measure() {
  const labels = edgeLabels()
  if (rootEl.value) narrow.value = rootEl.value.clientWidth < NARROW_WIDTH_PX
  if (!labels.length) return
  insetLeft.value = Math.max(0, labels[0].offsetWidth / 2 - DOT_RADIUS_PX)
  insetRight.value = Math.max(0, labels[labels.length - 1].offsetWidth / 2 - DOT_RADIUS_PX)
}

let frame: number | undefined
function scheduleMeasure() {
  if (frame !== undefined) cancelAnimationFrame(frame)
  frame = requestAnimationFrame(() => {
    frame = undefined
    measure()
  })
}

let observer: ResizeObserver | undefined
function observe() {
  observer?.disconnect()
  if (!observer || !rootEl.value) return
  observer.observe(rootEl.value)
  edgeLabels().forEach((label) => observer?.observe(label))
}

onMounted(() => {
  if (typeof ResizeObserver !== 'undefined') observer = new ResizeObserver(scheduleMeasure)
  observe()
  measure()
})

watch([() => props.current, () => props.steps], async () => {
  await nextTick()
  observe()
  scheduleMeasure()
})

onBeforeUnmount(() => {
  observer?.disconnect()
  if (frame !== undefined) cancelAnimationFrame(frame)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: "w-full overflow-hidden"
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ paddingLeft: `${insetLeft.value}px`, paddingRight: `${insetRight.value}px` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: step }, [
            _createElementVNode("div", {
              "data-testid": "create-schedule-step-indicator",
              class: _normalizeClass(["w-4 h-4 shrink-0 rounded-full", _ctx.current >= index ? 'bg-primary30' : 'bg-gray-300'])
            }, null, 2),
            (index < _ctx.steps.length - 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex-grow h-[2px] mx-2", _ctx.current > index ? 'bg-primary30' : 'bg-gray-300'])
                }, null, 2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (_ctx.hideLabels)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Etapa " + _toDisplayString(_ctx.current + 1) + " de " + _toDisplayString(_ctx.steps.length), 1))
        : _createCommentVNode("", true),
      (!_ctx.hideLabels)
        ? (_openBlock(), _createElementBlock("ol", {
            key: 1,
            "aria-label": "Etapas da criação de escala",
            class: "grid list-none p-0 mt-2 mb-0",
            style: _normalizeStyle(labelGridStyle.value)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: step,
                class: "flex justify-center px-0.5",
                "aria-current": _ctx.current === index ? 'step' : undefined
              }, [
                _createElementVNode("span", {
                  "data-testid": "create-schedule-step-label",
                  class: _normalizeClass(["w-fit leading-tight text-center break-normal hyphens-none", [narrow.value ? 'text-xs' : 'text-sm', labelColorClass(index)]])
                }, _toDisplayString(step), 3)
              ], 8, _hoisted_3))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ], 4)
  ], 512))
}
}

})